import React, { useState, useEffect, useMemo } from "react";
import { Spinner } from "react-activity";
import { loader } from "../../loader";
import { ENDPOINT } from "../../axios/apiConfig";
import { getData, postData } from "../../axios/apiHelper";
import { format, parseISO } from "date-fns";
import { countryRegionArray } from "../surveybuilder/surveyObjects/SurveyRegion";
import CommonConfirmModel from "../../Model/CommonConfirmModel";
import AskIbuModal from "./AskIbuTopics";
import { popup_alert } from "../../popup_alert";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import { Col, Tabs, Tab, Button, Form, Image } from "react-bootstrap";
import { saveAs } from "file-saver";

const AskIbu = () => {
  let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
  const [ibuQuestion, setIbuQuestion] = useState([]);
  const [answers, setAnswers] = useState({});
  const [editableAnswerId, setEditableAnswerId] = useState(null);
  const [Deleteconfirmationpopup, setDeleteConfirmationPopup] = useState(false);
  const [Topics, setTopics] = useState(false);
  const [allTopics, setAllTopics] = useState([]);
  const [isChecked, setChecked] = useState({});
  const [tabTopics, setTabTopics] = useState([]);
  const [questionId, setQuestionId] = useState([]);
  const [missingTopicWarningId, setMissingTopicWarningId] = useState(null);
  const [refresh, setrefresh] = useState("");
  const [commonConfirmModelFxn, setCommonConfirmModelFxn] = useState(() => {});
  const [activeTab, setActiveTab] = useState("private");
  const handleTabSelect = (key) => {
    setActiveTab(key);
  };

  const hideModal = (id) => {
    if (id) {
      setChecked((prevChecked) => {
        const updatedChecked = { ...prevChecked };
        delete updatedChecked[id];
        return updatedChecked;
      });
    }
    setDeleteConfirmationPopup(false);
  };

  const [popupMessage, setPopupMessage] = useState({
    message1: "",
    message2: "",
    footerButton: "",
    id: "",
  });

  const fetchTopics = async () => {
    try {
      loader("show");
      const res = await postData(ENDPOINT.GETALLTOPICS);
      setAllTopics(res?.data?.data || []);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      loader("hide");
    }
  };

  const refreshData = async (type) => {
    try {
      setrefresh(type);
      fetchIbuQuestionDetails();
    } catch (err) {
      console.log(err);
    }
  };

  const fetchTabTopics = async (item, id) => {
    setTopics(true);
    setTabTopics(item);
    setQuestionId(id);
  };

  const fetchIbuQuestionDetails = async () => {
    try {
      loader("show");
      const res = await getData(ENDPOINT.GETALLIBUQUESTIONS);
      setIbuQuestion(res?.data?.data || []);
    } catch (err) {
      console.error("Error fetching IBU question details:", err);
    } finally {
      loader("hide");
    }
  };

  const showConfirmationPopup = (
    stateMsg,
    e,
    id,
    userId,
    visibilityStatus,
    status
  ) => {
    if (stateMsg === "delete") {
      setCommonConfirmModelFxn(() => () => deleteUser(id));
      setPopupMessage({
        message1: "Are you sure you want to delete this question?",
        message2: "Once removed, it can't be restored",
        footerButton: "Yes please!",
      });
      setDeleteConfirmationPopup(true);
    } else if (stateMsg === "Private") {
      setDeleteConfirmationPopup(true);
      setPopupMessage({
        message1: "Are you sure you want to publish this question?",
        message2: "Once published,all users will be able to see it in Ask IBU",
        footerButton: "Yes please!",
        id: id,
      });
      setCommonConfirmModelFxn(
        () => () => confirmPublish(userId, visibilityStatus, status, id)
      );
    } else if (stateMsg === "Published") {
      setDeleteConfirmationPopup(true);
      setPopupMessage({
        message1: "Are you sure you want to take down this question?",
        message2:
          "Once removed,it will no longer appear in the Ask IBU section.",
        footerButton: "Yes please!",
        id: id,
      });
      setCommonConfirmModelFxn(
        () => () => confirmPublish(userId, visibilityStatus, status, id)
      );
    }
  };

  const downloadExcel = (data) => {
    try {
      if (data?.length === 0) {
        toast.warning("No data found");
        return;
      }

      const fileNames = {
        Private: "Private_Questions.xlsx",
        "Not Answer": "Questions.xlsx",
        Published: "Published_Questions.xlsx",
        Ignored: "Ignore_Questions.xlsx",
        "By Email": "Email_Questions.xlsx",
      };

      const processedData = data.map((item) => ({
        Question: item?.question?.trim() || "N/A",
        Answer: item?.answer?.trim() || "N/A",
        Country: item?.country?.trim() || "N/A",
        Name: item?.user_name?.trim() || "N/A",
        Visibility: item?.visibility_status || "N/A",
        Date: item?.created
          ? new Date(item.created.trim()).toLocaleString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })
          : "N/A",
        Status: item?.status || "N/A",
      }));

      const worksheet = XLSX.utils.json_to_sheet(processedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });

      const visibility = data[0]?.visibility_status;
      const fileName = fileNames[visibility] || "General_Questions.xlsx";

      saveAs(blob, fileName);
    } catch (error) {
      console.error(
        "An error occurred while downloading the Excel file:",
        error
      );
    }
  };

  const deleteUser = async (questionId) => {
    loader("show");
    try {
      const payload = { questionId };
      const res = await postData(ENDPOINT.DELETEQUESTION, payload);
      if (res?.status == "200") {
        loader("hide");
        popup_alert({
          visible: "show",
          message: "The question has been deleted <br/>successfully !",
          type: "success",
          redirect: "",
        });
        setUpdatdeData((prev) => !prev);
      }

      loader("hide");
    } catch (err) {
      loader("hide");
    }
    hideModal();
  };

  const confirmPublish = async (
    userId,
    visibilityStatus,
    status,
    questionId
  ) => {
    loader("show");
    const payload = {
      userId,
      visibilityStatus,
      status,
      questionId,
    };
    try {
      const res = await postData(ENDPOINT.UPDATEIBUQUESTIONSTATUS, payload);

      if (res.status === 200) {
        loader("hide");
        popup_alert({
          visible: "show",
          message:
            visibilityStatus === "Private"
              ? "The question has been removed from Ask IBU successfully!"
              : "The question has been published<br/>successfully!",

          type: "success",
          redirect: "",
        });
        setUpdatdeData((prev) => !prev);
      }
      loader("hide");
    } catch (err) {
      loader("hide");
    }
    hideModal();
  };

  useEffect(() => {
    fetchTopics();
  }, []);

  const [UpdatdeData, setUpdatdeData] = useState();
  useEffect(() => {
    fetchIbuQuestionDetails();
  }, [UpdatdeData]);

  const groupedQuestions = useMemo(
    () => ({
      private:
        ibuQuestion?.filter((q) => q.visibility_status === "Private") || [],
      published:
        ibuQuestion?.filter((q) => q.visibility_status === "Published") || [],
      byEmail:
        ibuQuestion?.filter((q) => q.visibility_status === "By Email") || [],
      Ignored:
        ibuQuestion?.filter((q) => q.visibility_status === "Ignored") || [],
      NotAnswer:
        ibuQuestion?.filter((q) => q.visibility_status === "Not Answer") || [],
    }),
    [ibuQuestion]
  );

  const handleAction = async (questionId, action, answer,question="") => {
    const payload = {
      questionId,
      action,
      answer,
      question
    };
  loader("show");
    try {
      const res = await postData(ENDPOINT.ADDEDITIBUANSWER, payload);
      if (res.status === 200) {
        setUpdatdeData((prev) => !prev);
      }
    } catch (err) {
      console.error("API call failed:", err);
       loader("hide");
    }finally{
      loader("hide");
    }
  };

  const EditAnswer = async (questionId, answer) => {
    const payload = {
      questionId,
      answer,
    };
    try {
      const res = await postData(ENDPOINT.UPDATEANSWER, payload);
      if (res.status === 200) {
        setUpdatdeData((prev) => !prev);
      }
    } catch (err) {
      console.error("API call failed:", err);
    }
  };
  const handleInput = (e, id) => {
  e.target.style.height = "auto"; // Reset height
  e.target.style.height = e.target.scrollHeight + "px"; // Set new height

  setAnswers((prev) => ({
    ...prev,
    [id]: e.target.value,
  }));
};

  return (
    <>
      <Col className="right-sidebar custom-change live-stream narrative-ibu">
        <div className="custom-container">
          <div className="top-header regi-web sticky speaker_zone">
            <div className="page-title">
              <h2>Ask IBU</h2>
            </div>
          </div>
          <div className="row">
            <Col className="col-6 left-col">
              <div className="doc-content-main-box col">
                <div className="live-stream-tabs-data">
                  <Tabs defaultActiveKey="questions" fill>
                    <Tab
                      eventKey="questions"
                      title="Questions "
                      className="flex-column"
                    >
                      <div className="doc-content-header">
                        <div className="askibu-doc-content d-flex justify-content-between align-items-center">
                          <h4>
                            All Asked Questions |{" "}
                            <span>
                              {groupedQuestions?.NotAnswer.length
                                ? groupedQuestions?.NotAnswer.length
                                : 0}
                            </span>
                          </h4>
                          <div className="clear-search d-flex align-items-center">
                            <button
                              className="btn print"
                              title="Download stats"
                              onClick={() => {
                                downloadExcel(groupedQuestions?.NotAnswer);
                              }}
                            >
                              <img
                                src={path_image + "download.svg"}
                                alt="Download"
                              />
                            </button>
                            <div className="btn-refresh">
                              <img
                                className={
                                  refresh == "Not Answer"
                                    ? "refresh-rotate"
                                    : ""
                                }
                                src={path_image + "refresh-btn.svg"}
                                alt=""
                                onClick={(e) => refreshData("Not Answer")}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="tab-panel d-flex flex-column justify-content-between">
                        {groupedQuestions?.NotAnswer.length > 0 ? (
                          groupedQuestions?.NotAnswer.map((item) => (
                            <div key={item.id} className="live-stream-ques">
                              <div className="live-stream-ques-header d-flex justify-content-between">
                                <div className="ask-ibu-hcp">
                                  <h4>{item.user_name}</h4>
                                  <p>
                                    {countryRegionArray?.[item?.country]
                                      ? countryRegionArray?.[item?.country]
                                      : item?.region ? item?.region : "N/A"}
                                    {item.country ? ", " + item.country : ""}
                                  </p>
                                </div>
                              </div>

                              <div className="reader-message">
                                <div className="reader-msg-show">
                                  <p>{item.question}</p>
                                  <div className="ask-ibu-date">
                                    {format(
                                      parseISO(item.created),
                                      "dd.LLLL.yyyy"
                                    ).toLowerCase()}
                                  </div>
                                </div>

                                <div className="user-comment">
                                  <Form.Control
                                  as="textarea"
                                   rows={1}
                                    size="lg"
                                    type="text"
                                    placeholder="Type your answer here... "
                                    value={
                                      answers[item.id] ?? item.answer ?? ""
                                    }
                                      onInput={(e) => handleInput(e, item.id)}
                                    onChange={(e) =>
                                      setAnswers((prev) => ({
                                        ...prev,
                                        [item.id]: e.target.value,
                                      }))
                                    }
                                  />
                                </div>
                              </div>

                              <div className="ask-ibu-action d-flex justify-content-between align-items-center">
                                <Button
                                  className="ignored"
                                  onClick={() =>
                                    handleAction(
                                      item.id,
                                      "Ignored",
                                      answers[item.id] ?? item.answer ?? null
                                    )
                                  }
                                >
                                  Ignore
                                </Button>

                                <div className="d-flex gap-4">
                                    {/* <Button
                                      className={
                                        answers[item.id] ?? item.answer
                                          ? "btn-filled"
                                          : "btn-disabled"
                                      }
                                    > */}
                                  <a
                                    className={
                                      answers[item.id] ?? item.answer
                                        ? "btn-filled answer_mail"
                                        : "btn-disabled answer_mail"
                                    }
                                    href={`mailto:${item.email}?subject=${encodeURIComponent(
                                      "Your VWD Journey Question Has Been Answered"
                                    )}&body=${encodeURIComponent(
                                      `Question: ${item.question}\n\n Answer: ${answers[item.id] ?? item.answer ?? ""}`
                                    )}`}
                                    onClick={() =>
                                      handleAction(
                                        item.id,
                                        "By Email",
                                        answers[item.id] ?? item.answer ?? ""
                                      )
                                    }
                                  >
                                    Answer by Email
                                  </a>
                                    {/* </Button> */}

                                  <Button
                                    className={
                                      answers[item.id] ?? item.answer
                                        ? "btn-filled"
                                        : "btn-disabled"
                                    }
                                    onClick={() =>
                                      handleAction(
                                        item.id,
                                        "Private",
                                        answers[item.id] ?? item.answer ?? "",
                                        item?.question
                                      )
                                    }
                                  >
                                    Answer in VWD journey
                                  </Button>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="no_found">
                            <p>No Data found</p>
                          </div>
                        )}
                      </div>
                    </Tab>

                    <Tab
                      eventKey="ignore"
                      title="ignore "
                      className="flex-column"
                    >
                      <div className="doc-content-header">
                        <div className="askibu-doc-content d-flex justify-content-between align-items-center">
                          <h4>
                            All Ignored Questions |{" "}
                            <span>
                              {groupedQuestions?.Ignored.length
                                ? groupedQuestions?.Ignored.length
                                : 0}
                            </span>
                          </h4>
                          <div className="clear-search d-flex align-items-center">
                            <button
                              className="btn print"
                              title="Download stats"
                              onClick={() => {
                                downloadExcel(groupedQuestions?.Ignored);
                              }}
                            >
                              <img
                                src={path_image + "download.svg"}
                                alt="Download"
                              />
                            </button>
                            <div className="btn-refresh">
                              <img
                                className={
                                  refresh == "Ignored" ? "refresh-rotate" : ""
                                }
                                src={path_image + "refresh-btn.svg"}
                                alt=""
                                onClick={(e) => refreshData("Ignored")}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="tab-panel d-flex flex-column justify-content-between">
                        {groupedQuestions?.Ignored.length > 0 ? (
                          groupedQuestions?.Ignored.map((item) => (
                            <div key={item.id} className="live-stream-ques">
                              <div className="live-stream-ques-header d-flex justify-content-between">
                                <div className="ask-ibu-hcp">
                                  <h4>{item.user_name}</h4>
                                  <p>
                                    {countryRegionArray?.[item?.country]
                                      ? countryRegionArray?.[item?.country]
                                      : "N/A"},{item.country}
                                  </p>
                                </div>
                              </div>
                              <div className="reader-message">
                                <div className="reader-msg-show">
                                  <p>{item.question}</p>
                                  <div className="ask-ibu-date">
                                    {format(
                                      parseISO(item.created),
                                      "dd.LLLL.yyyy"
                                    ).toLowerCase()}
                                  </div>
                                </div>
                                <div className="user-comment">
                                  <Form.Control
                                  as="textarea"
                                   rows={1}
                                    size="lg"
                                    type="text"
                                    placeholder="Type your answer here... "
                                    value={
                                      answers[item.id] ?? item.answer ?? ""
                                    }
                                    onInput={(e) => handleInput(e, item.id)}
                                    onChange={(e) =>
                                      setAnswers((prev) => ({
                                        ...prev,
                                        [item.id]: e.target.value,
                                      }))
                                    }
                                  />
                                </div>
                              </div>
                              <div className="ask-ibu-action d-flex justify-content-between align-items-center">
                                <div className="clear-search">
                                  <button
                                    onClick={(e) =>
                                      showConfirmationPopup(
                                        "delete",
                                        e,
                                        item.id
                                      )
                                    }
                                  >
                                    <img
                                      src={path_image + "delete-survey.svg"}
                                      alt="Delete"
                                    />
                                  </button>
                                </div>

                                <div className=" d-flex gap-2">
                                  <a
                                  className={
                                        answers[item.id] ?? item.answer
                                          ? "btn-filled answer_mail"
                                          : "btn-disabled answer_mail"
                                      }
                                     href={`mailto:${item.email}?subject=${encodeURIComponent(
                                      "Your VWD Journey Question Has Been Answered"
                                    )}&body=${encodeURIComponent(
                                      `Question: ${item.question}\n\n Answer: ${answers[item.id] ?? item.answer ?? ""}`
                                    )}`}

                                    onClick={() =>
                                      handleAction(
                                        item.id,
                                        "By Email",
                                        answers[item.id] ?? item.answer ?? ""
                                      )
                                    }
                                  >
                                      Answer by Email
                                  </a>
                                  <Button
                                    className={
                                      answers[item.id] ?? item.answer
                                        ? "btn-filled"
                                        : "btn-disabled"
                                    }
                                    onClick={() =>
                                      handleAction(
                                        item.id,
                                        "Private",
                                        answers[item.id] ?? item.answer ?? "",
                                        item?.question
                                      )
                                    }
                                  >
                                    Answer in VWD journey
                                  </Button>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="no_found">
                            <p>No Data found</p>
                          </div>
                        )}
                      </div>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </Col>

            <Col className="col-6 right-col">
              <div className="doc-content-main-box col">
                <div className="live-stream-tabs-data">
                  <Tabs
                    defaultActiveKey="private"
                    onSelect={handleTabSelect}
                    fill
                  >
                    <Tab
                      eventKey="private"
                      title="Private"
                      className="flex-column"
                    >
                      <div className="doc-content-header">
                        <div className="askibu-doc-content d-flex justify-content-between align-items-center">
                          <h4>
                            Answered Privately Questions |{" "}
                            <span>
                              {groupedQuestions?.private.length
                                ? groupedQuestions?.private.length
                                : 0}
                            </span>
                          </h4>
                          <div className="clear-search d-flex align-items-center">
                            <button
                              className="btn print"
                              title="Download stats"
                              onClick={() => {
                                downloadExcel(groupedQuestions?.private);
                              }}
                            >
                              <img
                                src={path_image + "download.svg"}
                                alt="Download"
                              />
                            </button>
                            <div className="btn-refresh">
                              <img
                                className={
                                  refresh == "Private" ? "refresh-rotate" : ""
                                }
                                src={path_image + "refresh-btn.svg"}
                                alt=""
                                onClick={(e) => refreshData("Private")}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="tab-panel d-flex flex-column justify-content-between">
                        {groupedQuestions?.private.length > 0 ? (
                          groupedQuestions?.private.map((item) => (
                            <div key={item.id} className="live-stream-ques">
                              <div className="live-stream-ques-header d-flex justify-content-between">
                                <div className="ask-ibu-hcp">
                                  <h4>{item.user_name}</h4>
                                  <p>
                                    {countryRegionArray?.[item?.country]
                                      ? countryRegionArray?.[item?.country]
                                      : "N/A"}
                                    , {item.country}
                                  </p>
                                </div>
                                <div className="save-cancel-btn  d-flex gap-4 align-items-center">
                                  {editableAnswerId === item.id ? (
                                    <>
                                      <button
                                        className="btn btn-primary btn-bordered"
                                        onClick={() => {
                                          setEditableAnswerId(null);
                                          setAnswers((prev) => {
                                            const updated = { ...prev };
                                            delete updated[item.id];
                                            return updated;
                                          });
                                        }}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        className="btn btn-primary btn-filled"
                                        // onClick={() => EditAnswer(item.id, answers[item.id] ?? item.answer ?? "") }
                                        onClick={() => {
                                          const answerText = (
                                            answers[item.id] ??
                                            item.answer ??
                                            ""
                                          ).trim();

                                          if (!answerText) {
                                            toast.error(
                                              "Answer field cannot be empty."
                                            );
                                            return;
                                          }

                                          EditAnswer(item.id, answerText);
                                          setEditableAnswerId(null);
                                        }}
                                      >
                                        Save
                                      </button>
                                    </>
                                  ) : (
                                    <div className="clear-search">
                                      <button
                                        className="btn print"
                                        title="edit"
                                        onClick={() => {
                                          setEditableAnswerId(item.id);
                                          setAnswers((prev) => ({
                                            ...prev,
                                            [item.id]: item.answer || "",
                                          }));
                                        }}
                                      >
                                        <img
                                          src={path_image + "edit-button.svg"}
                                          alt="Edit"
                                        />
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="reader-message">
                                <div className="reader-msg-show">
                                  <p>{item.question}</p>
                                  <div className="ask-ibu-date">
                                    {" "}
                                    {format(
                                      parseISO(item.created),
                                      "dd.LLLL.yyyy"
                                    ).toLowerCase()}
                                  </div>
                                </div>

                                <div className="user-comment">
                                  {editableAnswerId === item.id ? (
                                    <textarea
                                      className="inputactive"
                                      placeholder="Type your answer here... "
                                      value={
                                        answers[item.id] ?? item.answer ?? ""
                                      }
                                      onInput={(e) => handleInput(e, item.id)}
                                      onChange={(e) =>
                                        setAnswers((prev) => ({
                                          ...prev,
                                          [item.id]: e.target.value,
                                        }))
                                      }
                                      readOnly={editableAnswerId !== item.id}
                                    />
                                  ) : (
                                    <p>
                                      {answers[item.id] ?? item.answer ?? ""}
                                    </p>
                                  )}
                                </div>
                              </div>

                              <Form.Group className="form-group tags-group">
                                <div className="input-group d-flex w-100 align-items-center">
                                  <div className="tags_added ">
                                    {item.topics && item.topics.length > 0 ? (
                                      <ul>
                                        {item.topics.map((topic, idx) => (
                                          <li key={idx} className="list1">
                                            {topic}
                                          </li>
                                        ))}
                                      </ul>
                                    ) : (
                                      <span className="add-topic w-100">
                                        Add topics so users can easily filter
                                        and find questions
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </Form.Group>
                              {missingTopicWarningId === item.id && (
                                <div className="askibu-error-text">
                                  Please add at least one topic before
                                  publishing the question.
                                </div>
                              )}

                              <div className="ask-ibu-action d-flex justify-content-between align-items-center">
                                <div className="ask-ibu-btn d-flex gap-3 justify-content-center align-items-center">
                                  <div className="clear-search">
                                    <button
                                      onClick={(e) =>
                                        showConfirmationPopup(
                                          "delete",
                                          e,
                                          item.id
                                        )
                                      }
                                    >
                                      <img
                                        src={path_image + "delete-survey.svg"}
                                        alt="Delete"
                                      />
                                    </button>
                                  </div>
                                  <Button
                                    className="add-topics-btn"
                                    onClick={() => {
                                      fetchTabTopics(item.topics, item.id);
                                      setMissingTopicWarningId(null);
                                    }}
                                  >
                                    Add/edit topics
                                  </Button>
                                </div>

                                <div className="form-switch">
                                  <span>Private</span>
                                  <div className="form-check form-check-inline">
                                    <input
                                      type="checkbox"
                                      id={`custom-switch-${item.id}`}
                                      className="form-check-input"
                                      checked={
                                        isChecked[item.id] !== undefined
                                          ? isChecked[item.id]
                                          : activeTab === "published"
                                      }
                                      onChange={(e) => {
                                        const checked = e.target.checked;
                                        const visibilityStatus = checked
                                          ? "Published"
                                          : "Private";
                                        const status = checked ? "1" : "0";
                                        if (
                                          checked &&
                                          (!item.topics ||
                                            item.topics.length === 0)
                                        ) {
                                          setMissingTopicWarningId(item.id);
                                          return;
                                        }

                                        setMissingTopicWarningId(null);

                                        showConfirmationPopup(
                                          "Private",
                                          e,
                                          item.id,
                                          item.user_id,
                                          visibilityStatus,
                                          status
                                        );
                                        setChecked((prev) => ({
                                          ...prev,
                                          [item.id]: checked,
                                        }));
                                      }}
                                    />
                                  </div>
                                  <span className="publish">Publish</span>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="no_found">
                            <p>No Data found</p>
                          </div>
                        )}
                      </div>
                    </Tab>

                    <Tab
                      eventKey="published"
                      title="Published"
                      className="flex-column"
                    >
                      <div className="doc-content-header">
                        <div className="askibu-doc-content d-flex justify-content-between align-items-center">
                          <h4>
                            Published Questions |{" "}
                            <span>
                              {groupedQuestions?.published.length
                                ? groupedQuestions?.published.length
                                : 0}
                            </span>
                          </h4>
                          <div className="clear-search d-flex align-items-center">
                            <button
                              className="btn print"
                              title="Download stats"
                              onClick={() => {
                                downloadExcel(groupedQuestions?.published);
                              }}
                            >
                              <img
                                src={path_image + "download.svg"}
                                alt="Download"
                              />
                            </button>
                            <div className="btn-refresh">
                              <img
                                className={
                                  refresh == "Published" ? "refresh-rotate" : ""
                                }
                                src={path_image + "refresh-btn.svg"}
                                alt=""
                                onClick={(e) => refreshData("Published")}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="tab-panel d-flex flex-column justify-content-between">
                        {groupedQuestions?.published.length > 0 ? (
                          groupedQuestions?.published.map((item, index) => (
                            <div key={item.id} className="live-stream-ques">
                              <div className="live-stream-ques-header d-flex justify-content-between">
                                <div className="ask-ibu-hcp">
                                  <h4>{item.user_name}</h4>
                                  <p>
                                    {countryRegionArray?.[item?.country]
                                      ? countryRegionArray?.[item?.country]
                                      : "N/A"}
                                    , {item.country}
                                  </p>
                                </div>
                                <div className="save-cancel-btn  d-flex gap-4 align-items-center">
                                  {editableAnswerId === item.id ? (
                                    <>
                                      <button
                                        className="btn btn-primary btn-bordered"
                                        onClick={() => {
                                          setEditableAnswerId(null);
                                          setAnswers((prev) => {
                                            const updated = { ...prev };
                                            delete updated[item.id];
                                            return updated;
                                          });
                                        }}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        className="btn btn-primary btn-filled"
                                        // onClick={() => EditAnswer(item.id, answers[item.id] ?? item.answer ?? "") }
                                        //   onClick={() => {
                                        //   EditAnswer(item.id, answers[item.id] ?? item.answer ?? "");
                                        //   setEditableAnswerId(null);
                                        // }}
                                        onClick={() => {
                                          const answerText = (
                                            answers[item.id] ??
                                            item.answer ??
                                            ""
                                          ).trim();

                                          if (!answerText) {
                                            toast.error(
                                              "Answer field cannot be empty."
                                            );
                                            return;
                                          }

                                          EditAnswer(item.id, answerText);
                                          setEditableAnswerId(null);
                                        }}
                                      >
                                        Save
                                      </button>
                                    </>
                                  ) : (
                                    <div className="clear-search">
                                      <button
                                        className="btn print"
                                        title="edit"
                                        onClick={() => {
                                          setEditableAnswerId(item.id);
                                          setAnswers((prev) => ({
                                            ...prev,
                                            [item.id]: item.answer || "",
                                          }));
                                        }}
                                      >
                                        <img
                                          src={path_image + "edit-button.svg"}
                                          alt="Edit"
                                        />
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="reader-message">
                                <div className="reader-msg-show">
                                  <p>{item.question}</p>
                                  <div className="ask-ibu-date">
                                    {format(
                                      parseISO(item.created),
                                      "dd.LLLL.yyyy"
                                    ).toLowerCase()}
                                  </div>
                                </div>
                                <div className="user-comment">
                                  {editableAnswerId === item.id ? (
                                    <textarea
                                      className="inputactive"
                                      placeholder="Type your answer here..."
                                      value={
                                        answers[item.id] ?? item.answer ?? ""
                                      }
                                      onInput={(e) => handleInput(e, item.id)}
                                      onChange={(e) =>
                                        setAnswers((prev) => ({
                                          ...prev,
                                          [item.id]: e.target.value,
                                        }))
                                      }
                                      readOnly={editableAnswerId !== item.id}
                                    />
                                  ) : (
                                    <p>
                                      {answers[item.id] ?? item.answer ?? ""}
                                    </p>
                                  )}
                                </div>
                              </div>

                              <Form.Group className="form-group tags-group">
                                <div className="input-group d-flex w-100 align-items-center">
                                  <div className="tags_added">
                                    {item.topics && item.topics.length > 0 ? (
                                      <ul>
                                        {item.topics.map((topic, idx) => (
                                          <li key={idx} className="list1">
                                            {topic}
                                          </li>
                                        ))}
                                      </ul>
                                    ) : (
                                      <span className="add-topic w-100">
                                        Add topics so users can easily filter
                                        and find questions
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </Form.Group>

                              <div className="ask-ibu-action d-flex justify-content-between align-items-center">
                                <div className="ask-ibu-btn d-flex gap-3 justify-content-center align-items-center">
                                  <div className="clear-search ">
                                    <button
                                      onClick={(e) =>
                                        showConfirmationPopup(
                                          "delete",
                                          e,
                                          item.id
                                        )
                                      }
                                    >
                                      <img
                                        src={path_image + "delete-survey.svg"}
                                        alt="Delete"
                                      />
                                    </button>
                                  </div>
                                  <Button
                                    className="add-topics-btn"
                                    onClick={() => {
                                      fetchTabTopics(item.topics, item.id);
                                      setMissingTopicWarningId(null);
                                    }}
                                  >
                                    Add/edit topics
                                  </Button>
                                </div>

                                <div className="form-switch">
                                  <span>Private</span>
                                  <div className="form-check form-check-inline">
                                    <input
                                      type="checkbox"
                                      id={`custom-switch-${item.id}`}
                                      className="form-check-input"
                                      checked={
                                        isChecked[item.id] !== undefined
                                          ? isChecked[item.id]
                                          : activeTab === "published"
                                      }
                                      onChange={(e) => {
                                        const checked = e.target.checked;
                                        const visibilityStatus = checked
                                          ? "Published"
                                          : "Private";
                                        const status = checked ? "1" : "0";
                                        if (status) {
                                          showConfirmationPopup(
                                            "Published",
                                            e,
                                            item.id,
                                            item.user_id,
                                            visibilityStatus,
                                            status
                                          );
                                        }

                                        setChecked((prev) => ({
                                          ...prev,
                                          [item.id]: checked,
                                        }));
                                      }}
                                    />
                                  </div>
                                  <span className="publish">Publish</span>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="no_found">
                            <p>No Data found</p>
                          </div>
                        )}
                      </div>
                    </Tab>

                    <Tab
                      eventKey="byemail"
                      title="By Email"
                      className="flex-column"
                    >
                      <div className="doc-content-header">
                        <div className="askibu-doc-content d-flex justify-content-between align-items-center">
                          <h4>
                            Answered Questions By Email |{" "}
                            <span>
                              {groupedQuestions?.byEmail.length
                                ? groupedQuestions?.byEmail.length
                                : 0}
                            </span>
                          </h4>
                          <div className="clear-search d-flex align-items-center">
                            <button
                              className="btn print"
                              title="Download stats"
                              onClick={() => {
                                downloadExcel(groupedQuestions?.byEmail);
                              }}
                            >
                              <img
                                src={path_image + "download.svg"}
                                alt="Download"
                              />
                            </button>
                            <div className="btn-refresh">
                              <img
                                className={
                                  refresh == "By Email" ? "refresh-rotate" : ""
                                }
                                src={path_image + "refresh-btn.svg"}
                                alt=""
                                onClick={(e) => refreshData("By Email")}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="tab-panel d-flex flex-column justify-content-between">
                        {groupedQuestions?.byEmail.length > 0 ? (
                          groupedQuestions?.byEmail.map((item) => (
                            <div key={item.id} className="live-stream-ques">
                              <div className="live-stream-ques-header d-flex justify-content-between">
                                <div className="ask-ibu-hcp">
                                  <h4>{item.user_name}</h4>
                                </div>
                                <div className="ask-ibu-hcp">
                                  <p>
                                    {countryRegionArray?.[item?.country]
                                      ? countryRegionArray?.[item?.country]
                                      : "N/A"}
                                    , {item.country}
                                  </p>
                                </div>
                              </div>
                              <div className="reader-message">
                                <div className="reader-msg-show">
                                  <p>{item.question}</p>
                                  <div className="ask-ibu-date">
                                    {format(
                                      parseISO(item.created),
                                      "dd.LLLL.yyyy"
                                    ).toLowerCase()}
                                  </div>
                                </div>
                                <div className="user-comment">
                                  <Form.Control
                                   as="textarea"
                                    size="lg"
                                    type="text"
                                    placeholder="Type your answer here... "
                                    value={
                                      answers[item.id] ?? item.answer ?? ""
                                    }
                                    onInput={(e) => handleInput(e, item.id)}
                                    onChange={(e) =>
                                      setAnswers((prev) => ({
                                        ...prev,
                                        [item.id]: e.target.value,
                                      }))
                                    }
                                  />
                                </div>
                              </div>
                              <div className="ask-ibu-action d-flex justify-content-between align-items-center">
                                <div className="clear-search ">
                                  <button
                                    onClick={(e) =>
                                      showConfirmationPopup(
                                        "delete",
                                        e,
                                        item.id
                                      )
                                    }
                                  >
                                    <img
                                      src={path_image + "delete-survey.svg"}
                                      alt="Delete"
                                    />
                                  </button>
                                </div>
                                <div className="d-flex gap-2">
                                  <Button
                                    className={
                                      answers[item.id] ?? item.answer
                                        ? "btn-filled"
                                        : "btn-disabled"
                                    }
                                    onClick={() =>
                                      handleAction(
                                        item.id,
                                        "Private",
                                        answers[item.id] ?? item.answer ?? "",
                                        item?.question
                                      )
                                    }
                                  >
                                   Answer in VWD journey
                                  </Button>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="no_found">
                            <p>No Data found</p>
                          </div>
                        )}
                      </div>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </Col>
          </div>
        </div>
      </Col>
      <CommonConfirmModel
        show={Deleteconfirmationpopup}
        onClose={hideModal}
        fun={commonConfirmModelFxn}
        popupMessage={popupMessage}
        path_image={path_image}
        resetDataId=""
        onCloseCross={hideModal}
      />
      {Topics && (
        <AskIbuModal
          show={Topics}
          setShow={setTopics}
          showCurrent=""
          setShowCurrent=""
          topics={tabTopics}
          setTopics={setTabTopics}
          allTags={allTopics}
          setAllTags={setAllTopics}
          questionId={questionId}
          setUpdatdeData={setUpdatdeData}
        />
      )}
    </>
  );
};

export default AskIbu;
